const grayColor = '#C0C0C0';
const gridColor = '#e8e8e8';
const fontSize = 12;

export const defaultVerticalBarChartConfig = {
  scaleShowVerticalLines: false,
  maintainAspectRatio: false,
  responsive: true,

  tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        return data.datasets[0].data[tooltipItem.index];
      }
    }
  },

  plugins: {
    datalabels: {
      color: 'white',
      // WARNING: meta.data._model is PRIVATE and thus can
      // change without notice, breaking code relying on it!
      display: context => {
        const chart = context.chart;
        const meta = chart.getDatasetMeta(context.datasetIndex);

        const model = meta.data[context.dataIndex]._model;
        const top = Math.max(model.base, chart.chartArea.top);
        const heght = model.y + top;
        return heght > 25;
      },
      formatter: value => Math.round(value) /*+ '%'*/
    }
  },

  scales: {
    xAxes: [
      {
        gridLines: { display: false },
        ticks: {
          fontColor: grayColor,
          fontSize
        }
      }
    ],
    yAxes: [
      {
        gridLines: {
          color: gridColor
        },
        ticks: {
          fontColor: grayColor,
          fontSize,
          beginAtZero: true,
          userCallback: label => {
            // when the floored value is the same as the value we have a whole number
            if (Math.floor(label) === label) {
              return label + '%';
            }
          }
        }
      }
    ]
  }
};
